import React, { Component } from 'react';
import { Col, Container, Row } from 'reactstrap';
import { Redirect } from 'react-router-dom';

import { LogoHeader } from '../../../containers/Components/index'

import instagram_square from '../../../assets/img/instagram-square.png';

class Privacy extends Component {
  constructor(props) {
    super(props);
    this.state = {
      login: false,
      signup: false,
      warning: "",
      showVerify: false,
      html_btn_status: 0,
    };
    this.user_name = "";
    this.pwd = "";
  }

  renderRedirect = () => {
    if (this.state.login) {
      return <Redirect to= { '/login/'} />
    }
    if (this.state.signup) {
      return <Redirect to= { '/register/'} />
    }
  }
  render() {

    // let slider_count = 4;
    // if (window.innerWidth < 520) {
    //   slider_count = 4;
    // }

    return (
      <div className="app flex-row font-Poppins">
      {this.renderRedirect()}
        <React.Fragment>
        <LogoHeader />
        
        <div className="app-body p-0 m-0 width-100vw mt-5 ">
            <Container className = "background-white" fluid>
               <Row className = "about_page_gradient mt-3 ">
                 <Col className = "d-md-down-none" xs="6" sm="6" lg="2">
                 </Col>
                 <Col xs="6" sm="6" lg="2">
                  <h5 className = "m-3 text-white"> Privacy </h5>
                 </Col>
                </Row>
                <Row>
                  <Col className = "d-md-down-none" xs="6" sm="6" lg="2">
                  </Col>
                  <Col xs="12" sm="12" lg="8">
                    <h6 className = "mt-5 pt-2 line-height-h">
                    Your privacy is critically important to us. This Statement of Privacy governs 
                    data collection and usage and applies to https://www.abilitaxr.com. 
                    For the purposes of this Privacy Policy, unless otherwise noted, all references 
                    to ‘AbilitàXR’ include https://www.abilitaxr.com and AbilitàXR. By using the AbilitàXR website, 
                    you consent to the data practices described in this statement.
                    </h6>
                    <h6 className = "mt-4 line-height-h">
                    <b>Website Visitors</b>
                    <br></br>
                    Like most website operators, AbilitàXR collects non-personally-identifying 
                    information of the sort that web browsers and servers typically make available, 
                    such as the browser type, language preference, referring site, 
                    and the date and time of each visitor request. 
                    AbilitàXR’s purpose in collecting non-personally identifying information is 
                    to better understand how AbilitàXR’s visitors use its website. 
                    From time to time, AbilitàXR may release non-personally-identifying information in the aggregate, 
                    e.g., by publishing a report on trends in the usage of its website.
                    <br></br>
                    AbilitàXR also collects potentially personally-identifying information 
                    like Internet Protocol (IP) addresses for logged in users. AbilitàXR only discloses logged in user 
                    IP addresses under the same circumstances that it uses and discloses 
                    personally-identifying information as described below.
                    </h6>
                    <h6 className = "mt-4 line-height-h">
                    <b>Gathering of Personally-Identifying Information</b>
                    <br></br>
                    Certain visitors to AbilitàXR’s websites choose to interact with AbilitàXR in ways that require 
                    AbilitàXR to gather personally-identifying information. The amount and type of information that 
                    AbilitàXR gathers depends on the nature of the interaction. In each case, AbilitàXR collects such 
                    information only insofar as is necessary or appropriate to fulfill the purpose of the visitor’s 
                    interaction with AbilitàXR. AbilitàXR does not disclose personally-identifying information other than 
                    as described below. And visitors can always refuse to supply personally-identifying information, 
                    with the caveat that it may prevent them from engaging in certain website-related activities.
                    </h6>
                    <h6 className = "mt-4 line-height-h">
                    <b>Aggregated Statistics</b>
                    <br></br>
                    AbilitàXR may collect statistics about the behavior of visitors to its websites. 
                    AbilitàXR may display this information publicly or provide it to others. However, 
                    AbilitàXR does not disclose personally-identifying information other than as described below.
                    </h6>
                    <h6 className = "mt-4 line-height-h">
                    <b>Protection of Certain Personally-Identifying Information</b>
                    <br></br>
                    AbilitàXR discloses potentially personally-identifying and personally-identifying information 
                    only to those of its employees, contractors and affiliated organizations that (i) need to 
                    know that information in order to process it on AbilitàXR’s behalf or to provide services 
                    available at AbilitàXR’s websites, and (ii) that have agreed not to disclose it to others. 
                    Some of those employees, contractors and affiliated organizations may be located outside 
                    of your home country; by using AbilitàXR’s websites, you consent to the transfer of such 
                    information to them. AbilitàXR will not rent or sell potentially personally-identifying and 
                    personally-identifying information to anyone. Other than to its employees, contractors and 
                    affiliated organizations, as described above, AbilitàXR discloses potentially personally-identifying 
                    and personally-identifying information only in response to a subpoena, court order or 
                    other governmental request, or when AbilitàXR believes in good faith that disclosure is 
                    reasonably necessary to protect the property or rights of AbilitàXR, third parties or the 
                    public at large. If you are a registered user of AbilitàXR and have supplied your email address, 
                    AbilitàXR may occasionally send you an email to tell you about new features, solicit your feedback, 
                    or just keep you up to date with what’s going on with AbilitàXR and our products. 
                    If you send us a request (for example via a support email or via one of our feedback mechanisms), 
                    we reserve the right to publish it in order to help us clarify or respond to your request or to 
                    help us support other users. AbilitàXR takes all measures reasonably necessary to protect against 
                    the unauthorized access, use, alteration or destruction of potentially personally-identifying 
                    and personally-identifying information.
                    </h6>
                    <h6 className = "mt-4 line-height-h">
                    <b>Cookies</b>
                    <br></br>
                    A cookie is a string of information that a website stores on a visitor’s computer, 
                    and that the visitor’s browser provides to the website each time the visitor returns. 
                    AbilitàXR uses cookies to help AbilitàXR identify and track visitors, their usage of AbilitàXR website, 
                    and their website access preferences. AbilitàXR visitors who do not wish to have cookies placed on 
                    their computers should set their browsers to refuse cookies before using AbilitàXR’s websites, 
                    with the drawback that certain features of AbilitàXR’s websites may not function properly 
                    without the aid of cookies.
                    </h6>
                    <h6 className = "mt-4 line-height-h">
                    <b>Business Transfers</b>
                    <br></br>
                    If AbilitàXR, or substantially all of its assets, were acquired, or in the unlikely event 
                    that AbilitàXR goes out of business or enters bankruptcy, user information would be one of 
                    the assets that is transferred or acquired by a third party. You acknowledge that such 
                    transfers may occur, and that any acquirer of AbilitàXR may continue to use your personal 
                    information as set forth in this policy.
                    </h6>
                    <h6 className = "mt-4 line-height-h">
                    <b>Ads</b>
                    <br></br>
                    Ads appearing on any of our websites may be delivered to users by advertising partners, 
                    who may set cookies. These cookies allow the ad server to recognize your computer each 
                    time they send you an online advertisement to compile information about you or others 
                    who use your computer. This information allows ad networks to, among other things, 
                    deliver targeted advertisements that they believe will be of most interest to you. 
                    This Privacy Policy covers the use of cookies by AbilitàXR and does not cover the use of cookies 
                    by any advertisers.
                    </h6>
                    <h6 className = "mt-4 line-height-h">
                    <b>Privacy Policy Changes</b>
                    <br></br>
                    Although most changes are likely to be minor, AbilitàXR may change its Privacy Policy from 
                    time to time, and in AbilitàXR’s sole discretion. AbilitàXR encourages visitors to frequently 
                    check this page for any changes to its Privacy Policy. Your continued use of this site 
                    after any change in this Privacy Policy will constitute your acceptance of such change.
                    </h6>
                    <h6 className = "mt-4 line-height-h">
                    <br></br>
                    <br></br>
                    </h6>
                  </Col>  
                  <Col className = "d-md-down-none" xs="6" sm="6" lg="2">
                  </Col>
                </Row>
                  {/* -------------- Footer Start -------- */}
                <Row className="mt-5">
                </Row>
                <Row className="pt-5 pb-5 home-background-gray">
                  <Col xs="0" sm="0" lg="1">
                  </Col>
                  <Col xs="4" sm="4" lg="2">
                    <Row className = "ml-2 text-left">
                      <Col className="mt-5 mb-4" md = '12'> 
                        <div>PRODUCT</div>
                      </Col>
                      <Col className="mb-2 text-secondary" md = '12'> 
                         <a href = "/feature"><div className = "font-size-10" >Features</div></a>
                      </Col>
                      <Col className="mb-2 text-secondary" md = '12'> 
                        <a href = "/appguide"><div className = "font-size-10" >App Guide</div></a>
                      </Col>
                      <Col className = "mb-2 text-secondary"  md = '12'> 
                        <div className = "font-size-10" >Platform Guide</div>
                      </Col>
                      <Col className = "mb-2 text-secondary"  md = '12'> 
                        <a href = "/customdev"><div className = "font-size-10" >Custom Development</div></a>
                      </Col>
                      <Col className = "mb-2 text-secondary"  md = '12'> 
                        <div className = "font-size-10" >Pricing</div>
                      </Col>
                      <Col className = "mb-2 text-secondary"  md = '12'> 
                        <a href = "https://goo.gl/1s6PZH" target="_blank" rel="noopener noreferrer">
                        <div className = "font-size-10" >Get VR Headset</div></a>
                      </Col>
                    </Row>
                  </Col>
                  <Col xs="4" sm="4" lg="2">
                    <Row className = "text-left ml-2">
                      <Col className="mt-5 mb-4" md = '12'> 
                        <div >USE CASES</div>
                      </Col>
                      <Col className="mb-2 text-secondary" md = '12'> 
                        <a href = "/realestate"><div className = "font-size-10" >Real Estate</div></a>
                      </Col>
                      <Col className="mb-2 text-secondary" md = '12'> 
                        <a href = "/architecture"><div className = "font-size-10" >Architecture</div></a>
                      </Col>
                      <Col className = "mb-2  text-secondary" md = '12'> 
                        <a href = "/medical"><div className = "font-size-10" >Medical</div></a>
                      </Col>
                      <Col className = "mb-2 text-secondary" md = '12'> 
                        <a href = "/retail"><div className = "font-size-10" >Retail</div></a>
                      </Col>
                      <Col className = "mb-2 text-secondary" md = '12'> 
                        <a href = "/sports"><div className = "font-size-10" >Sports</div></a>
                      </Col>
                      <Col className = "mb-2 text-secondary" md = '12'> 
                        <a href = "/media"><div className = "font-size-10" >Media</div></a>
                      </Col>
                      <Col className = "mb-2 text-secondary" md = '12'> 
                        <a href = "/travel"><div className = "font-size-10" >Travel</div></a>
                      </Col>
                      <Col className = "mb-2 text-secondary" md = '12'> 
                        <a href = "/education"><div className = "font-size-10" >Education</div></a>
                      </Col>
                      <Col className = "mb-2 text-secondary" md = '12'> 
                        <a href = "/training"><div className = "font-size-10" >Training</div></a>
                      </Col>
                      <Col className = "mb-2 text-secondary" md = '12'> 
                        <a href = "/ecommerce"><div className = "font-size-10" >Ecommerce</div></a>
                      </Col>
                      <Col className = "mb-2 text-secondary" md = '12'> 
                        <a href = "/entertainment"><div className = "font-size-10" >Entertainment</div></a>
                      </Col>
                    </Row>
                  </Col>
                  <Col xs="4" sm="4" lg="2">
                    <Row className = "text-left ml-2">
                      <Col className="mt-5 mb-4" md = '12'> 
                        <div>Support</div>
                      </Col>
                      <Col className="mb-2 text-secondary" md = '12'> 
                        <a href = "http://www.icomputinglabs.in/blog/" target="_blank" rel="noopener noreferrer">
                        <div className = "font-size-10" >Blog</div> </a>
                      </Col>
                      <Col className="mb-2 text-secondary" md = '12'> 
                        <a href = "/faq"><div className = "font-size-10" >FAQ</div></a>
                      </Col>
                      <Col className = "mb-2 text-secondary" md = '12'> 
                        <a href = "/contact"><div className = "font-size-10" >Contact</div></a>
                      </Col>
                    </Row>
                  </Col>
                  <Col xs="6" sm="6" lg="2">
                    <Row className = "text-left ml-2">
                      <Col className="mt-5 mb-4" md = '12'> 
                        <div>COMPANY</div>
                      </Col>
                      <Col className="mb-2 text-secondary" md = '12'> 
                        <a href = "/about"><div className = "font-size-10" >About</div></a>
                      </Col>
                      <Col className="mb-2 text-secondary" md = '12'> 
                        <a href = "/privacy"><div className = "font-size-10" >Privacy Policy</div></a>
                      </Col>
                      <Col className = "mb-2 text-secondary" md = '12'> 
                        <a href = "/tos"><div className = "font-size-10" >Terms of Service</div></a>
                      </Col>
                    </Row>
                  </Col>
                  <Col xs="6" sm="6" lg="2">
                    <Row className = "text-left ml-2">
                      <Col className="mt-5 mb-4" md = '12'> 
                        <div>GET CONNECTED</div>
                      </Col>
                      <Col className="mb-2 text-secondary" md = '12'> 
                        <a href = "https://www.facebook.com/icomputinglabs/" target="_blank" rel="noopener noreferrer">
                        <div className = "font-size-10" ><i className = "text-primary fa fa-facebook-square fa-lg mr-2" />facebook</div>
                        </a>
                      </Col>
                      <Col className="mb-2 text-secondary" md = '12'> 
                        <a href = "https://www.instagram.com/icomputinglabs/" target="_blank" rel="noopener noreferrer">
                        <div className = "font-size-10" ><img  alt="" src={instagram_square} className = "text-primary width-16 mr-2" />instagram</div>
                        </a>
                      </Col>
                      <Col className = "mb-2 text-secondary"  md = '12'> 
                        <a href = "https://twitter.com/iComputingLabs" target="_blank" rel="noopener noreferrer">
                        <div className = "font-size-10" ><i className = "text-primary fa fa-twitter-square fa-lg mr-2" />twitter</div>
                        </a>
                      </Col>
                      <Col className = "mb-2 text-secondary"  md = '12'>
                        <a href = "https://www.linkedin.com/company/13404850/" target="_blank" rel="noopener noreferrer">
                        <div className = "font-size-10" ><i className = "text-primary fa fa-linkedin-square fa-lg mr-2" />linkedin</div>
                        </a>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              {/* -------------- Footer End -------- */}
            </Container>
        </div>
        </React.Fragment>
      </div>
    );
  }
}

export default Privacy;



// WEBPACK FOOTER //
// ./src/views/Pages/Privacy/Privacy.js